import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { PlayArrow, CheckCircle, Check } from "@material-ui/icons";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default class ApproveOtTransaction extends Component {
  constructor(props) {
    super();
    this.state = {
      updated_by: cookies.get("email"),
      created_by: cookies.get("email"),
      disableSubmit: false,
      hasError: false,
      showModal: false,
      type: 'EARNING',
      errMessage: ""
    };
    this.handleShowModal = this.handleShowModal.bind(this);
  }

  handleShowModal = (e) => {
    this.setState({
      showModal: !this.state.showModal,
      hasError: false,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableSubmit: true });
    axios
      .put("api/transaction_continue/" + this.props.transId, this.state)
      .then((res) => {
        this.props.parentCallback(true);
        this.setState({
          showModal: false,
          disableSubmit: false,
          hasError: true,
        });
      })
      .catch((err) => {
        this.setState({ disableSubmit: false, hasError: true, errMessage: err.response.data.message });
      });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-success btn-sm float-right"
          title="Approved Pending OT"
          onClick={this.handleShowModal}
        >
          <Check />
        </button>
        <Modal
          size="md"
          show={this.state.showModal}
          onHide={() =>
            this.setState({ showModal: !this.state.showModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Approved Pending OT: {this.props.name}</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div
                  className={
                    this.state.hasError
                      ? "alert alert-danger"
                      : "alert alert-danger d-none"
                  }
                  role="alert"
                >
                  {this.state.errMessage}
                </div>
              </div>
            </div>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  Are you sure?
                </div>
              </div>

              <div className="float-right">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                  disabled={this.state.disableSubmit}
                >
                  Continue
                </button>
                <button
                  onClick={this.handleShowModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
